import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getDistanceUnitList as getDistanceUnitListApi,
	getDistanceUnitListQuery as getDistanceUnitListQueryApi,
	getDistanceUnit as getDistanceUnitApi,
	addNewDistanceUnitApi,
	updateDistanceUnitApi,
	deleteDistanceUnitApi,
	checkDistanceUnitExistsApi,
} from '../../helpers/distance_unit/api_helper';

export const getDistanceUnitList = createAsyncThunk(
	'distanceUnit/getDistanceUnitList',
	async () => {
		try {
			const response = await getDistanceUnitListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las unidades de distancia.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getDistanceUnitListQuery = createAsyncThunk(
	'distanceUnit/getDistanceUnitListQuery',
	async params => {
		try {
			const response = getDistanceUnitListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getDistanceUnit = createAsyncThunk(
	'distanceUnit/getDistanceUnit',
	async distance_unit_id => {
		try {
			const response = await getDistanceUnitApi(distance_unit_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la unidad de distancia.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewDistanceUnit = createAsyncThunk(
	'distanceUnit/addNewDistanceUnit',
	async distance_unit => {
		try {
			const response = await addNewDistanceUnitApi(distance_unit);
			toast.success('Unidad de Distancia agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la unidad de distancia.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateDistanceUnit = createAsyncThunk(
	'distanceUnit/updateDistanceUnit',
	async distance_unit => {
		try {
			const response = await updateDistanceUnitApi(distance_unit);
			toast.success('Unidad de Distancia actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la unidad de distancia.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteDistanceUnit = createAsyncThunk(
	'distanceUnit/deleteDistanceUnit',
	async distance_unit => {
		try {
			const response = await deleteDistanceUnitApi(distance_unit._id);
			toast.success('Unidad de Distancia eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return distance_unit;
		} catch (error) {
			toast.error('Error al eliminar la unidad de distancia.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkDistanceUnitExists = createAsyncThunk(
	'distanceUnit/checkDistanceUnitExists',
	async name => {
		try {
			const response = await checkDistanceUnitExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
